import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalLeger from './modal/legerSuper';
import { faBookOpenReader } from '@fortawesome/free-solid-svg-icons';
import { PulseLoader} from "react-spinners";
import ModalRapor from './modal/rapor';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  .wali-kelas-label{
    font-size: 13px;
    font-weight: 600;
    color: #2e52aeff;
    margin-top: 12px;
  }
  `;

export default function Leger() {
  document.title = "Rapor";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataTeacher, setGetDataTeacher] = useState([]);

  // Tingkatan & Kelas
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");

  // Table data
  const [getData, setGetData] = useState([]);
  const [getDataKop, setGetDataKop] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id:"",
    ysb_kelas_id:"",
    ysb_teacher_id: "",
  });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
    setPermission({ create: 1, read: 1, update: 1, delete: 1 });
    return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
    setPermission({
    create: foundPermission.create,
    read: foundPermission.read,
    update: foundPermission.update,
    delete: foundPermission.delete,
    });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
    headers: {
    Authorization: `${token}`,
    "Content-Type": "application/json",
    },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
  
  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // =========================
  // INIT: Branch + Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes, dimensiRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } 

  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;
      setLoadingSchool(true); // ⬅️ school mulai load
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // ✅ FILTER ULANG UNTUK ROLE DEVELOPER
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            // reset dependensi saat sekolah berubah (tingkatan/kelas/guru)
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "", ysb_teacher_id: "" }));
            setGetDataTeacher([]);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
          initSchoolDone.current = true;
          setLoadingSchool(false); // ⬅️ school SELESAI
          setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
      }
    },[ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
    );
  };

  const sortKelas = (kelas) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;
      initKelasDone.current = false; // reset kelas juga, karena kelas tergantung level

      if (!schoolId) return;

      setLoadingLevel(true);
      try {
        const res = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let levels = res.data?.data || [];

          // filter by sekolah + cabang 
          levels = levels.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

          levels = sortLevels(levels);
          setGetDataLevel(levels);

          if (levels.length === 0) {
            // kalau memang tidak ada tingkatan, kelas dianggap selesai juga
            initKelasDone.current = true;
          }

          // default tingkatan pertama
          if (levels.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: levels[0].id,
            }));
          } else {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
            }));

          setGetDataKelas([]);
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    }, [fetchParams]
  );

  // ketika sekolah berubah -> reset tingkatan & kelas -> fetch tingkatan
  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    return;
    }

    // reset dulu biar tidak nyangkut data sekolah sebelumnya
    setGetDataLevel([]);
    setGetDataKelas([]);
    setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

  // =========================
  // Fetch kelas saat tingkatan berubah
  // =========================
  const fetchKelasByLevel = useCallback(
    async (gradeLevelId, schoolId, branchId) => {
      initKelasDone.current = false;

      if (!gradeLevelId) return;

      setLoadingKelas(true);
      try {
        const res = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let kelas = res.data?.data || [];

          // filter by tingkatan + (opsional) sekolah/cabang
          kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
          if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

          kelas = sortKelas(kelas);
          setGetDataKelas(kelas);

          // default kelas pertama
          if (kelas.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_kelas_id: kelas[0].id,
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    }, [fetchParams]
  );

  useEffect(() => {
    if (!form2.ysb_grade_level_id) {
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      return;
    }

    // reset kelas dulu, lalu fetch ulang
    setGetDataKelas([]);
    setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
  // =========================
  // Filter complete (Guru gak wajib)
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id &&
    (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
    (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id 
      // !form2.ysb_dimensi_id
    ) return;

    const params = {
      ysb_semester_id: form2.ysb_semester_id,
      level: storageLevel,
      branch: form2.ysb_branch_id,
      // ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_school_id: form2.ysb_school_id,
    };

    // ✅ tingkatan & kelas opsional (akan terisi default dari select)
    if (form2.ysb_grade_level_id) {
      params.ysb_grade_level_id = form2.ysb_grade_level_id;
    }
    if (form2.ysb_kelas_id) {
      params.ysb_kelas_id = form2.ysb_kelas_id;
    }

    try {
      const response = await APILA.get(
        "/api/element-recaps-rapot/rapot",
        {
        params,
        ...fetchParams,
        }
      );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
      setGetDataKop(response.data.data_kop || []);
    }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [form2, fetchParams, storageLevel]);

  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // AUTO LOAD
  useEffect(() => {
    const schoolReady =
      initSchoolDone.current &&
      !loadingSchool &&
      !!form2.ysb_school_id;

    const gradeReady =
      initLevelDone.current &&
      !loadingLevel &&
      (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

    const kelasReady =
      initKelasDone.current &&
      !loadingKelas &&
      (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_dimensi_id ||
      !schoolReady ||
      !gradeReady ||
      !kelasReady
    ) return;

    firstLoadDone.current = true;

    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ sekarang pasti sudah bawa default tingkatan+kelas
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
    getDataLevel.length,
    getDataKelas.length,
  ]);


  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
  ]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (loadingSchool || loadingLevel || loadingKelas) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });
      return;
    }

    const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
    const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !form2.ysb_dimensi_id || !gradeRequired || !kelasRequired) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester, Cabang, Sekolah, Tingkatan, Kelas, dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);
    setSearchKeyword("");

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


  // =========================
  // Nama Wali Kelas (diambil dari data kelas yang dipilih jika tersedia)
  // =========================
  const selectedKelasObj = useMemo(() => {
    if (!form2.ysb_kelas_id) return null;
    return (getDataKelas || []).find((k) => String(k?.id) === String(form2.ysb_kelas_id)) || null;
  }, [form2.ysb_kelas_id, getDataKelas]);
  
  const waliKelasName = useMemo(() => {
    // Sesuai request: tampilkan wali kelas dari field `ysb_name_teacher`
    const fromKelas =
      selectedKelasObj?.ysb_name_teacher ||
        "";
  
    const fromData =
      (Array.isArray(getData) &&
        getData.length > 0 &&
        (getData[0]?.ysb_name_teacher || getData[0]?.name_teacher || getData[0]?.teacher_name)) ||
      "";
  
    return safeStr(fromKelas || fromData);
  }, [getData, selectedKelasObj]);
  
  // =========================
  // Filter + Search + Sorting (frontend)
  // - Filter tingkatan/kelas diterapkan dari frontend (jika field tersedia di data rapor)
  // - Nama siswa diurutkan A -> Z
  // =========================
  const displayedData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];
   
    // Filter Tingkatan (jika field ada di row)
    if (form2.ysb_grade_level_id) {
      const selectedLevelId = String(form2.ysb_grade_level_id);
        rows = rows.filter((r) => {
          const rowLevelId = r?.ysb_grade_level_id;
          if (!rowLevelId) return true; // kalau field tidak ada, jangan dibuang
          return String(rowLevelId) === selectedLevelId;
        });
    }
   
    // Filter Kelas (jika field ada di row)
    if (form2.ysb_kelas_id) {
      const selectedKelasId = String(form2.ysb_kelas_id);
      rows = rows.filter((r) => {
        const rowKelasId =
          r?.ysb_kelas_id;
        if (!rowKelasId) return true;
        return String(rowKelasId) === selectedKelasId;
      });
    }
   
    // Search (Nama siswa / NISN)
    const q = safeStr(searchKeyword).trim().toLowerCase();
    if (q) {
      rows = rows.filter((r) => {
        const name = safeStr(r?.name_student).toLowerCase();
        const nisn = safeStr(r?.nisn).toLowerCase();
        return name.includes(q) || nisn.includes(q);
      });
    }
   
    // Sort nama siswa A -> Z
    rows.sort((a, b) => collator.compare(safeStr(a?.name_student), safeStr(b?.name_student)));

    return rows;
  }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);


  // const [showModal, setShowModal] = useState(false);
  // const [selectedRapor, setSelectedRapor] = useState(null);
  // const [dataKopRapor, setdataKopRapor] = useState(null);
      
  // const viewModalRapor = (id, rapor) => {
  //   try {
  //     setSelectedRapor(rapor || null);
  //     setShowModal(true);
  //     setdataKopRapor(getDataKop);
  //   } catch (err) {
  //     console.error('viewModalRapor error', err);
  //   }
  // }

  const [showModal, setShowModal] = useState(false);
  const [selectedRapor, setSelectedRapor] = useState(null);
  const [dataKopRapor, setdataKopRapor] = useState(null);

  const viewModalRapor = (id, rapor) => {
    try {
      // tutup dulu sebentar agar modal tidak membawa state murid sebelumnya
      setShowModal(false);

      setTimeout(() => {
        setSelectedRapor(rapor || null);
        setdataKopRapor(getDataKop || null);
        setShowModal(true);
      }, 0);
    } catch (err) {
      console.error("viewModalRapor error", err);
    }
  };

  const handleCloseModalRapor = () => {
    setShowModal(false);
    setSelectedRapor(null);
    setdataKopRapor(null);
  };

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body" >
        {/* <div className="body-header d-flex">
          {isTabletOrMobile ? 
            <>
              <div className="title-page">
                <h6><FontAwesomeIcon icon={faListUl}/> Rapor</h6>
              </div> 
            </>
            : 
            <>
              <div className="title-page">
                <h5><FontAwesomeIcon icon={faListUl}/> Rapor </h5>
              </div>
            </>
          }   
        </div>  */}
        <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faBookOpenReader} />
                  </span>
                <h4 className="page-title-text"> Rapor</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Rapor
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faBookOpenReader} />
                </span>
                <h4 className="page-title-text"> Rapor</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Rapor
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

        {/* <div className="body-content-menu">
          <div className="breadcrumb-header " style={{fontSize:"13px" }}>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"> <Link style={{textDecoration:"none"}} to="/dashboards-main">Beranda</Link>  </li>
                <li className="breadcrumb-item iniaktif" > <span className='ml-2'> Rapor </span> </li>
              </ol>
            </nav>
          </div>
        </div> */}
                    
        <div className="body-content">
        
          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester})
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    Pilih Cabang
                  </option>
                  {getDataBranch.map((user, index) => (
                    <option key={index} value={user?.branch_code}>
                      {user?.branch_name}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                 <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                        </select>
                      

                        

                       
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
<select
                          className="mr-2"
                          name="ysb_grade_level_id"
                          value={form2.ysb_grade_level_id}
                          onChange={handleChange}
                          disabled={loadingLevel}
                          style={{
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                            cursor: loadingLevel ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                          </option>

                          {!loadingLevel &&
                            getDataLevel.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_level}
                              </option>
                            ))}
                        </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
 <select
                          className="mr-2"
                          name="ysb_kelas_id"
                          value={form2.ysb_kelas_id}
                          onChange={handleChange}
                          disabled={loadingKelas}
                          style={{
                            border: "1px solid #3f5bea",
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                            cursor: loadingKelas ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                          </option>

                          {!loadingKelas &&
                            getDataKelas.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_kelas}
                              </option>
                            ))}
                        </select>
              </Row>

              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                    </div>
                    
                    <div className="d-flex">
                       <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                       <div className="shimmer shimmer-select mr-2" style={{width:200, borderRadius: "12px"}} />
                       <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_branch_id"
                          value={form2.ysb_branch_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            Pilih Cabang
                          </option>
                          {getDataBranch.map((user, index) => (
                            <option key={index} value={user?.branch_code}>
                              {user?.branch_name}
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="mt-3 d-flex">

                        <select
                          className="mr-2"
                          name="ysb_grade_level_id"
                          value={form2.ysb_grade_level_id}
                          onChange={handleChange}
                          disabled={loadingLevel}
                          style={{
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                            cursor: loadingLevel ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                          </option>

                          {!loadingLevel &&
                            getDataLevel.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_level}
                              </option>
                            ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_kelas_id"
                          value={form2.ysb_kelas_id}
                          onChange={handleChange}
                          disabled={loadingKelas}
                          style={{
                            border: "1px solid #3f5bea",
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                            cursor: loadingKelas ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                          </option>

                          {!loadingKelas &&
                            getDataKelas.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_kelas}
                              </option>
                            ))}
                        </select>
                        
                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                             padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                          }}
                        >
                          Cari
                        </button>

                      </div>
                    </div>
                )
              }
              </div>
              
            </>           
          )}

         {/* LOADER di area table (opsional tapi bagus) */}
            {isFetching && (
              <div className="text-center" style={{ padding: "10px 0" }}>
                <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
              </div>
          )}


          {/* TABLE hanya muncul jika sudah search (atau first load selesai) */}
          {hasSearched && !isFetching && (
            <>
              {/* ✅ Nama Wali Kelas */}
              {!!waliKelasName && <div className="wali-kelas-label">Wali Kelas: {toTitleCase(waliKelasName)}</div>}
              
              {/* ✅ Search */}
              <div className="mt-3">
                <div className="at-search">
                  <input
                    className="at-input"
                    placeholder="Cari Siswa / NISN"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>
              </div>

              <Col xl='12' sm='12'> 
                          <div className="mt-3">
                            <div className="body-table" >
                              <div>
                                <table className="table  w-100 table-hover table-bordered" id="basic-datatable">
                                  <thead >
                                    <tr >
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">No</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Nama Siswa</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Nisn</th>
                                      <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}} className="text-center">Aksi</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {displayedData.length === 0 ? (
                                      <tr>
                                        <td colSpan={4} className="text-center" style={{ padding: "18px 8px" }}>
                                          Data tidak ditemukan
                                        </td>
                                      </tr>
                                    ) : (
                                      displayedData.map((rapor, index) => (
                                        <tr key={rapor?.ysb_student_id || rapor?.id || index}>
                                          <td className="text-center" style={{ lineHeight: "2" }}>
                                            {index + 1}
                                          </td>
                                          <td style={{ lineHeight: "2" }}>{toTitleCase(rapor.name_student)}</td>
                                          {/* <td style={{ lineHeight: "2" }}>{rapor.name_student}</td> */}
                                          <td style={{ lineHeight: "2", textAlign: "center" }}>{rapor.nisn}</td>
                                          <td className="text-center">
                                            <button
                                              className="button-edit button-table text-center"
                                              onClick={() => viewModalRapor(rapor?.ysb_student_id || rapor?.id, rapor)}
                                            >
                                              Lihat Rapor
                                            </button>
                                          </td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </Col>

                      </>
                  )}

          {/* {selectedRapor && (
            <ModalRapor
              show={showModal}
              onHide={() => setShowModal(false)}
              data_rapor={selectedRapor}
              data_kop={dataKopRapor}
              id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
              getData={getData}
            />
          )} */}

          {selectedRapor && (
            <ModalRapor
              key={selectedRapor?.ysb_student_id || selectedRapor?.id}
              show={showModal}
              onHide={handleCloseModalRapor}
              data_rapor={selectedRapor}
              data_kop={dataKopRapor}
              id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
              getData={getData}
            />
          )}

        </div>
      </div>
    </>
  );
}
